var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectionIcon = function SvgSelectionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 11h2v2H3zm8-6h2v14h-2zm-2 6h2v2H9zm-4 0h2v2H5zm10 0h2v2h-2zm2 0h2v2h-2zm2 0h2v2h-2zM1 11h2v2H1zm6 0h2v2H7zm6 0h2v2h-2z"
  })));
};
export default SvgSelectionIcon;